import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Partner, PartnerDocument } from './partner.model';

export type ResourceType = 'card';

@CwtModel({ name: 'card', path: '/card' })
export class Card extends ApiData {
    partner?: Partner;
    name?: DictionaryObject;
    description?: DictionaryObject;
    picture?: PartnerDocument;
    documents?: PartnerDocument[];
    type?: ResourceType;
    order?: number;
}
